import { useEffect, useState } from 'react';
import { getShippingConfig, DEFAULT_SHIPPING_CONFIG, type ShippingConfig } from '@/services/shipping';

// Configuración de fletes de Interrapidísimo (local / regional / nacional).
export function useShippingConfig() {
  const [config, setConfig] = useState<ShippingConfig>(DEFAULT_SHIPPING_CONFIG);

  useEffect(() => {
    let cancelled = false;
    getShippingConfig().then((c) => {
      if (!cancelled) setConfig(c);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return config;
}